import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import usePaginationParams from '@hooks/usePaginationParams';

import type { CampaignType } from './types';

const useGetList = () => {
  const [campaigns, setCampaigns] = useState<CampaignType[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getCampaigns = useCallback(async ({ page = 1, limit = 10, name = '', portfolioId = '' }) => {
    setLoading(true);
    const params = {
      pageIndex: page,
      pageLimit: limit,
      name: name || undefined,
      portfolioId: portfolioId || undefined,
    };

    try {
      const response = await api.get('/campaign', {
        params,
      });

      setCampaigns(response.data.data);
      setTotalPages(response.data.total);
    } catch (error) {
      toast.error('Erro ao carregar campanhas. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get campaigns'), {
        error,
        params,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  usePaginationParams({ onParamsChange: getCampaigns });

  return {
    getCampaigns,
    campaigns,
    totalPages,
    loading,
  };
};

export default useGetList;
